import * as wasm from "./validators_web_bg.wasm";
export * from "./validators_web_bg.js";
import { __wbg_set_wasm } from "./validators_web_bg.js";
__wbg_set_wasm(wasm);